import { css } from 'styled-components';

const FormFieldLabel = css`
    font-weight: 600;
    color: #4A4A4A;
    padding: 8px 0;
    font-size: 14px;
`;

export default FormFieldLabel;
